export const ME_SCHEME = 'me://';
export const CONTEXT_OPEN = '[';
export const CONTEXT_CLOSE = ']';
export const CONTEXT_BRANCH_SEPARATOR = '|';
export const CONTEXT_AND_SEPARATOR = ';';
export const CONTEXT_VALUE_SEPARATOR = ',';
